<div [formGroup]="parentForm">
	<div formArrayName="lines">
		<p-table [value]="linesArray.controls" styleClass="p-datatable-sm document-lines-table"
			responsiveLayout="stack">
			<ng-template pTemplate="header">
				<tr>
					<th style="width: 30px;">#</th>
					<th style="width: 110px; overflow: hidden; text-overflow: ellipsis;">{{
						'routes.document.product' | translate }}</th>
					<th style="min-width: 70px; overflow: hidden; text-overflow: ellipsis;">{{
						'routes.document.description' | translate }}</th>
					<th style="width: 110px;">{{ 'routes.document.quantity' | translate }}</th>
					<th style="width: 170px;">{{ 'routes.document.pricePerUnit' | translate }}</th>
					<th style="width: 140px;">{{ 'routes.document.discount' | translate }}</th>
					<th style="width: 170px;" class="text-right">{{ 'routes.document.subTotal' | translate }}</th>
					<th style="width: 170px;" class="text-right">{{ 'routes.document.vatShort' | translate }} {{
						vatPercentage | number:'1.0-2' }}%</th>
					<th style="width: 170px;" class="text-right">{{ 'routes.document.total' | translate }}</th>
					<th style="width: 40px;" class="text-center">{{ 'routes.document.actions' | translate }}</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-lineCtrl let-i="rowIndex">
				<tr app-document-line [lineGroup]="lineCtrl" [lineIndex]="i" [vatPercentage]="vatPercentage"
					[submitted]="submitted" [debug]="debug" [productsList]="productsList"
					[isClosed]="linesClosedStates[i]"
					(removeLine)="removeLine($event)">
				</tr>
				<tr class="d-md-none" *ngIf="i === linesArray.controls.length - 1">
					<td class="p-3">
						<span class="p-column-title">{{ 'routes.document.total' | translate }}</span>
						{{ currentSummary?.payment_amount_including_vat | number:'1.2-2' }}
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="10" class="text-center">{{ 'routes.document.noLines' | translate }}</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="footer">
				<tr class="table-light fw-bold">
					<td [attr.colspan]="6" class="text-end">{{ 'routes.document.totals' | translate }}:</td>
					<td class="text-right">
						<span class="p-column-title">{{ 'routes.document.subTotal' | translate }}</span>
						{{ currentSummary?.payment_amount | number:'1.2-2' }}
					</td>
					<td class="text-right">
						<span class="p-column-title">{{ 'routes.document.vatShort' | translate }} {{ vatPercentage | number:'1.0-2' }}%</span>
						{{ currentSummary?.all_vat_amount | number:'1.2-2' }}
					</td>
					<td class="text-right">
						<span class="p-column-title">{{ 'routes.document.total' | translate }}</span>
						{{ currentSummary?.payment_amount_including_vat | number:'1.2-2' }}
					</td>
					<td></td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<div class="p-3 d-flex gap-2">
	<button pButton pRipple type="button" icon="pi pi-plus" [label]="'routes.document.addLine' | translate"
		class="p-button-sm p-button-outlined add-product-line" (click)="addLine()"></button>
	<button pButton pRipple type="button" icon="pi pi-box" [label]="'routes.document.addProduct' | translate"
		class="p-button-sm p-button-outlined d-none d-md-inline" (click)="showAddProductDialog()"></button>
</div>

<p-dialog
	header="{{ 'routes.document.addProduct' | translate }}"
	[(visible)]="displayAddProductModal"
	[modal]="true"
	[style]="{ width: 'min(96vw, 1280px)', 'min-width': '350px' }"
	[contentStyle]="{ maxHeight: 'min(88vh, 860px)', overflow: 'auto' }"
	[draggable]="false"
	[resizable]="false"
	[maximizable]="true"
	[breakpoints]="{'768px': '100vw'}"
	(onHide)="displayAddProductModal=false"
	styleClass="add-product-dialog-responsive">
	<app-add-product-modal *ngIf="displayAddProductModal" [companyId]="documentCompanyId"
		(productAdded)="onProductAdded($event)" (cancel)="displayAddProductModal=false">
	</app-add-product-modal>
</p-dialog>